import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { interval } from 'rxjs';
import { JdData } from '../common-interfaces-classes/JdData';
import { SearchtoolboxService } from '../_services/searchtoolbox.service';
@Component({
  selector: 'app-gen-ai-jd-search',
  templateUrl: './gen-ai-jd-search.component.html',
  styleUrls: ['./gen-ai-jd-search.component.scss']
})
export class GenAiJdSearchComponent implements OnInit {
  loadCount: number = 0;
  loadData: number = 0;
  delayInSeconds: number = 1;
  delayedItems: any[] = [];
  @Input() description = "";
  @Output() genAIEvent: EventEmitter<any> = new EventEmitter();
  showanimation: boolean = false;
  jdresponse: any;
  private jdResponse: JdData = null;
  constructor(private activeModal: NgbActiveModal, private searchtoolbox: SearchtoolboxService) { }


  ngOnInit() {
    this.increaseProgress();
  }

  progressValue: number = 0;
  intervalValue: number = 0;

  increaseProgress() {
    const interval$ = interval(500); // Change interval duration as needed
    
    const subscription = interval$.subscribe(() => {
      this.progressValue += 10;
      if (this.progressValue >= 80) {
        this.progressValue = !this.jdResponse ? 95 : 100;
        if (this.progressValue === 100) {
          subscription.unsubscribe();
          setTimeout(() => this.activeModal.close(this.jdResponse), 500);
        }
      }
    });

    if (this.description) {
      this.searchtoolbox.jdJSONDetails(null, this.description,"description").subscribe((res: JdData) => {
        this.jdResponse = res;
      })
    }
  }
}

